import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import configConstants from "../configConstants";
import { customerTagTypes } from "../features/management/customer-management/services/customerTypes";

import { siteTagTypes } from "../features/management/site-management/services/siteTypes";
import { locationTagTypes } from "../features/management/location-management/services/locationTypes";
import { meterTagTypes } from "../features/management/meter-management/services/meterTypes";
import { usersTagTypes } from "../features/management/user-management/services/userTypes";
import { dashboardTagTypes, forecastTagType } from "../features/dashboard/services/dashboardTypes";
import { contractTagTypes } from "../features/management/contract-management/services/contractTypes";

// Define a service using a base URL and expected endpoints
const baseURL = configConstants.VITE_ENERGY_GAIN_BASE_URL;
export const energyGainApi = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: baseURL,
    // credentials: "same-origin",
    credentials: "include",
    mode: "cors",
  }),

  // TODO: combine different endpoints defined in features/[featureName]/services See https://redux-toolkit.js.org/rtk-query/usage/code-splitting
  tagTypes: [
    ...customerTagTypes,
    ...siteTagTypes,
    ...locationTagTypes,
    ...meterTagTypes,
    ...usersTagTypes,
    ...dashboardTagTypes,
    ...forecastTagType,
    ...contractTagTypes,
  ],
  endpoints: () => ({}),
  reducerPath: "energyGainApi",
  keepUnusedDataFor: 0,
});

// eslint-disable-next-line no-empty-pattern
export const {} = energyGainApi;
